import { Flex, Text, useDisclosure } from "@chakra-ui/react";
import UpgradeCheckoutModal from "components/UpgradeCheckoutModal/UpgradeCheckoutModal";
import { IconUpgrade } from "icons";

interface UpgradeTagProps {
  carId: string;
}

const UpgradeTag = ({ carId }: UpgradeTagProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Flex
        background="linear-gradient(225deg, rgba(109, 241, 229, 0.2) 0%, rgba(79, 197, 186, 0.2) 18%, rgba(38, 166, 154, 0.2) 73%, rgba(26, 116, 107, 0.2) 100%)"
        borderRadius="4px"
        position="relative"
        _before={{
          content: '""',
          position: "absolute",
          inset: 0,
          borderRadius: "4px",
          padding: "2px",
          background: "linear-gradient(360deg, rgba(76, 194, 183, 0.6) 0%, rgba(76, 194, 183, 0.24) 100%)",
          mask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
          maskComposite: "exclude",
        }}
        gap="2"
        shadow="0px 2px 6px 2px rgba(0, 0, 0, 0.15)"
        alignItems="center"
        px="8px"
        pr="12px"
        py="8px"
        cursor="pointer"
        onClick={(e) => {
          e.stopPropagation(); // Prevent triggering parent click
          onOpen();
        }}
      >
        <IconUpgrade 
          __css={{
            path: {
              fill: "rgba(53, 255, 236, 0.8)"
            }
          }}
          boxSize={4}
        />

        <Text
          fontSize="12.5px"
          lineHeight="16px"
          fontWeight="400"
          fontFamily="heading"
          color="rgba(53, 255, 236, 0.8)"
        >
          UPGRADE
        </Text>
      </Flex>

      <UpgradeCheckoutModal
        isOpen={isOpen}
        onClose={onClose}
        carId={carId}
      />
    </>
  );
};

export default UpgradeTag;